import React from 'react';
import PropTypes from 'prop-types';
import { CONTENT_ITEM } from 'config/types/prop';

const DefaultLandingPage = ({ item }) => (
  <div>{item.title}</div>
);

DefaultLandingPage.propTypes = {
  item: PropTypes.shape(CONTENT_ITEM).isRequired,
};

export default DefaultLandingPage;
